import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    const fleetId = localStorage.getItem('fleetId');
    let newHeaders = req.headers;
    if (token && fleetId) {
      newHeaders = newHeaders.append('X-TransfloMobile-FleetId', fleetId);
      newHeaders = newHeaders.append('Authorization', 'Basic ' + token);
    }
    const cloned = req.clone({ headers: newHeaders });
    return next.handle(cloned);
  }
}
